import { BankOutlined, CalculatorOutlined, CalendarOutlined, DollarOutlined, FileTextOutlined, SafetyCertificateOutlined, TeamOutlined, UserOutlined, WalletOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, Card, Col, Flex, Form, Row, Space, Statistic, Table } from "antd";
import { useForm } from "antd/es/form/Form";
import { FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { MainLayout } from "components/layouts";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import dayjs from 'dayjs';
import { useNavigate, useParams } from "react-router-dom";

const GroupCalculation = ({
    payrollPeriodId = null,
    modifiedColumn = [],
    dataSource = [],
    getTableForm = () => { },
    paginationSize = [],
    calSuccess = [],
    onPaginationSizeChange = () => { },
    onSubmitAll = () => { },
    onRecalculation = () => { },
    column = [],
    getFilter = () => { },
    modelOt = () => { },
    isLoading = false
}) => {
    const { t, i18n } = useTranslation()
    const params = useParams();
    const navigate = useNavigate();



    // console.log("calSuccess", calSuccess, dataSource, dataSource.flatMap(item => item.deduction ?? [])
    //     ?.filter(o => o.deduction.code != 'D01')
    // );
    // ?.reduce((accumulator, currentValue) => {
    //         console.log("currentValue", currentValue);

    //         return accumulator + (currentValue.amount ?? 0)
    //     }, 0)
    const {
        payrollPeriod,
    } = useSelector((state) => state.payment)

    console.log("payrollPeriod", payrollPeriod);

    function PayrollPeriodInfo({ periodLabel, employmentTypeLabel, roundStart, roundEnd }) {
        const items = [
            {
                icon: <CalendarOutlined />,
                title: "งวดเดือน",
                value: periodLabel,
            },
            {
                icon: <UserOutlined />,
                title: "ประเภทการจ้างงาน",
                value: employmentTypeLabel,
            },
            {
                icon: <CalendarOutlined />,
                title: "รอบการทำเงินเดือน",
                value: `${roundStart} - ${roundEnd}`,
            },
        ];

        return (
            <div style={{
                background: "#F8FAFC",
                border: "1px solid #E5E7EB",
                borderRadius: 12,
                padding: "16px 24px",
                marginBottom: 16,
            }}>
                <div style={{
                    display: "flex",
                    flexWrap: "wrap",
                    columnGap: 64,
                    rowGap: 12,
                }}>
                    {items.map((item) => (
                        <div
                            key={item.title}
                            style={{ display: "flex", alignItems: "center", gap: 10 }}
                        >
                            <span style={{ fontSize: 22, color: "#2563EB", flexShrink: 0 }}>
                                {item.icon}
                            </span>
                            <div>
                                <div style={{
                                    fontSize: 13,
                                    color: "#42526D",
                                    fontFamily: "NotoSansThai",
                                    whiteSpace: "nowrap",
                                }}>
                                    {item.title}
                                </div>
                                <div style={{
                                    fontSize: 15,
                                    fontWeight: 700,
                                    color: "#42526D",
                                    fontFamily: "NotoSansThai",
                                    whiteSpace: "nowrap",
                                }}>
                                    {item.value}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
    function PayrollOverview() {
        return (
            <>
                <PayrollPeriodInfo
                    periodLabel={`${dayjs(String(payrollPeriod?.month, "MM")).format('MMMM')} ${payrollPeriod?.specialPeriod == "Y" ? t("payment_period.label.special_period") : t("payment_period.label.period_no")} ${payrollPeriod?.periodNo}`}
                    employmentTypeLabel={payrollPeriod?.employmentType?.map((o) => (
                        i18n.language === 'en' ? o?.employmentTypeNameEn : o?.employmentTypeName
                    ))}
                    roundStart={i18n.language === "en" ? dayjs(payrollPeriod?.startPeriod).format("DD/MM/YYYY") : dayjs(payrollPeriod?.startPeriod).format("DD/MM/BBBB")}
                    roundEnd={i18n.language === "en" ? dayjs(payrollPeriod?.endPeriod).format("DD/MM/YYYY") : dayjs(payrollPeriod?.endPeriod).format("DD/MM/BBBB")}
                />
                <PayrollSummary />
            </>
        );
    }

    const summary = [
        {
            title: "จำนวนพนักงาน",
            value: dataSource.length,
            icon: <TeamOutlined />,
            iconColor: "#3B82F6",
            iconBg: "#EFF6FF",
            valueStyle: { color: "#111827" },
        },
        {
            title: "รายได้รวม (GROSS)",
            value: dataSource.map(o => o.income)
                ?.reduce((accumulator, currentValue) => {
                    return accumulator + currentValue.reduce((sum1, v1) => sum1 + Number(v1.amount), 0)
                }, 0),
            icon: <DollarOutlined />,
            iconColor: "#16A34A",
            iconBg: "#ECFDF5",
            precision: 2,
            valueStyle: { color: "#16A34A" },
        },
        {
            title: "รายจ่ายอื่น",
            value: dataSource.flatMap(item => item?.deduction ?? [])
                ?.filter(o => o?.deduction?.code != 'D01' && o?.deduction?.code != 'D02').map(o => o.amount)?.reduce((accumulator, currentValue) => {
                    return accumulator + (Number(currentValue) ?? 0)
                }, 0),
            icon: <FileTextOutlined />,
            iconColor: "#EF4444",
            iconBg: "#FEF2F2",
            precision: 2,
            valueStyle: { color: "#EF4444" },
        },
        {
            title: "ประกันสังคม",
            value: dataSource.flatMap(item => item.deduction ?? [])
                ?.filter(o => o?.deduction?.code == 'D02').map(o => o.amount)?.reduce((accumulator, currentValue) => {
                    return accumulator + (Number(currentValue) ?? 0)
                }, 0),
            icon: <SafetyCertificateOutlined />,
            iconColor: "#EF4444",
            iconBg: "#FEF2F2",
            precision: 2,
            valueStyle: { color: "#EF4444" },
        },
        {
            title: "ภาษีหัก ณ ที่จ่าย",
            value: dataSource.flatMap(item => item.deduction ?? [])
                ?.filter(o => o?.deduction?.code == 'D01').map(o => o.amount)?.reduce((accumulator, currentValue) => {
                    return accumulator + (Number(currentValue) ?? 0)
                }, 0),
            icon: <BankOutlined />,
            iconColor: "#EF4444",
            iconBg: "#FEF2F2",
            precision: 2,
            valueStyle: { color: "#EF4444" },
        },
        {
            title: "รายได้สุทธิ (NET)",
            value: dataSource.flatMap(item => item.income ?? []).map(o => o.amount)?.reduce((accumulator, currentValue) => {
                return accumulator + (Number(currentValue) ?? 0)
            }, 0) - dataSource.flatMap(item => item.deduction ?? []).map(o => o.amount)?.reduce((accumulator, currentValue) => {
                return accumulator + (Number(currentValue) ?? 0)
            }, 0),
            icon: <WalletOutlined />,
            iconColor: "#16A34A",
            iconBg: "#ECFDF5",
            precision: 2,
            valueStyle: { color: "#16A34A" },
        },
    ];

    function formatValue(value, precision) {
        if (typeof value !== "number") return value;
        return value.toLocaleString("en-US", {
            minimumFractionDigits: precision ?? 0,
            maximumFractionDigits: precision ?? 0,
        });
    }

    function PayrollSummary() {
        return (
            <Row gutter={[16, 16]}>
                {summary.map((item) => (
                    <Col xs={24} sm={12} md={8} lg={4} key={item.title}>
                        <Card
                            size="small"
                            style={{
                                height: "5em",
                                width: "100%",
                                border: "1px solid #E5E7EB",
                                borderRadius: 12,
                            }}
                            styles={{
                                body: {
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "0 16px",
                                }
                            }}
                        >
                            <Row align="middle" wrap={false} gutter={12} style={{ width: "100%" }}>
                                <Col flex="none">
                                    <div style={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: "50%",
                                        background: item.iconBg,
                                        color: item.iconColor,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: "1em",
                                    }}>
                                        {item.icon}
                                    </div>
                                </Col>
                                <Col flex="auto" style={{ minWidth: 0 }}>
                                    <div style={{
                                        fontSize: "0.85em",
                                        color: "#6B7280",
                                        fontFamily: "NotoSansThai",
                                        whiteSpace: "nowrap",
                                    }}>
                                        {item.title}
                                    </div>
                                    <div style={{
                                        fontSize: "1em",
                                        fontWeight: 700,
                                        fontFamily: "NotoSansThai",
                                        ...item.valueStyle,
                                    }}>
                                        {formatValue(item.value, item.precision)}
                                        {typeof item.value === "number" && (
                                            <span style={{
                                                fontSize: "1em",
                                                fontWeight: 400,
                                                color: "#6B7280",
                                                marginLeft: 4,
                                            }}>
                                                {item.title === "จำนวนพนักงาน" ? "คน" : "บาท"}
                                            </span>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                ))}
            </Row>
        );
    }

    return (
        <MainLayout>
            <Space direction="vertical" size={5} style={{ width: "100%" }}>
                <Flex vertical>
                    <Breadcrumb items={[
                        { title: t("home.header"), link: "/" },
                        { title: t("payroll.header"), href: "/payroll" },
                        { title: t("payment_period.header"), href: `/payroll/payment/${payrollPeriodId}` },
                    ]} />
                    <h2>{t("payroll.header")}</h2>
                    {/* <Tabs
                        onChange={onPageTypeChange}
                        tabBarStyle={{ justifyContent: 'space-between' }}
                    >
                        {PAYMENT_STEP.map(tab => (
                            <TabPane
                                key={tab.key}
                                tab={i18n.language === 'en' ? tab.nameEn : tab.name}
                            />
                        ))}
                    </Tabs> */}
                </Flex>
                <Row>
                    <Col span={9} />
                    <Col span={6} >
                        <Flex justify="space-between">
                            {
                                getFilter()
                            }
                        </Flex></Col>
                    <Col span={9} >
                    </Col>
                </Row>
                <Row gutter={[5, 15]}>
                    <Col span={24}>
                        {PayrollOverview()}
                    </Col>
                    <Col span={24}>
                        {modelOt()}
                        {getTableForm()}
                    </Col>
                </Row>
                {/* <LeaveTypeForm {...props} /> */}
            </Space>
            <div
                style={{
                    position: "sticky",
                    bottom: 0,
                    zIndex: 10,
                    justifyContent: "center",
                    background: "#fff",
                    borderTop: "1px solid #E5E7EB",
                    boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.06)",
                    padding: "16px 24px",
                    marginTop: 16,
                    marginLeft: -24,  // cancel out MainLayout's content padding so the bar spans edge-to-edge
                    marginRight: -24, // adjust/remove these two if MainLayout doesn't have 24px side padding
                }}
            >
                <Flex justify="space-between" gap={12}>
                    <Button
                        onClick={() => {
                            navigate(`/payroll/payment/${params.id}`);
                        }}
                        loading={isLoading}
                        style={{ backgroundColor: "#2cade7", color: "white" }}
                    >
                        {t("common.back")}
                    </Button>
                    <Flex justify="flex-end" gap={12}>
                        <Button
                            onClick={onRecalculation}
                            loading={isLoading}
                            style={{ backgroundColor: "#ffa500", color: "white" }}
                        >
                            <CalculatorOutlined />{t("common.recal")}
                        </Button>

                        <Button
                            // type="primary"
                            style={{ backgroundColor: calSuccess.length != dataSource.length ? "gray" : "#2cade7", color: "white" }}
                            onClick={onSubmitAll}
                            loading={isLoading}
                            disabled={calSuccess.length != dataSource.length}
                        >
                            {t("common.save")}
                        </Button>
                    </Flex>
                </Flex>
            </div>
        </MainLayout>
    )
}

export default GroupCalculation